import React, { memo } from 'react';
import {
  MailAddressPropertyDomainPulldown,
  MailAddressDomainPulldownInput,
  FormPageInputItemMailAddressDomainPulldown,
  mappedConst,
} from 'shared';
import { FormFieldInputItemProps } from '../shared';

type UpdateKey = keyof Pick<
  FormPageInputItemMailAddressDomainPulldown,
  'local' | 'domain'
>;
const UPDATE_KEY: mappedConst<UpdateKey> = {
  local: 'local',
  domain: 'domain',
};

type Props = FormFieldInputItemProps<
  MailAddressPropertyDomainPulldown,
  FormPageInputItemMailAddressDomainPulldown
> & {
  local: FormPageInputItemMailAddressDomainPulldown['local'];
  domain: FormPageInputItemMailAddressDomainPulldown['domain'];
};

export const MailAddressDomainPulldown: React.FC<Props> = memo(
  ({
    property,
    local: localValue,
    domain: domainValue,
    disabled,
    design,
    onChange,
    onBlur,
    className,
    errorMessages,
    displayError,
    reEnter,
  }) => {
    const { propertyId, inputFormat } = property;
    const { placeholder } = inputFormat.local;
    const createChangeHandler =
      (updateKey: UpdateKey) => (inputData: string) => {
        onChange(updateKey, inputData);
      };
    const createBlurHandler = (updateKey: UpdateKey) => (inputData: string) => {
      onBlur(updateKey, inputData);
    };
    return (
      <MailAddressDomainPulldownInput
        propertyId={propertyId}
        placeholder={reEnter ? '' : placeholder}
        domains={inputFormat.domain}
        local={localValue}
        domain={domainValue}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onLocalChange={createChangeHandler(UPDATE_KEY.local)}
        onDomainChange={createChangeHandler(UPDATE_KEY.domain)}
        onLocalBlur={createBlurHandler(UPDATE_KEY.local)}
        onDomainBlur={createBlurHandler(UPDATE_KEY.domain)}
        design={design}
        className={className}
      />
    );
  }
);
